import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { CustomerPdf, SellerPdf } from '../pdfGenerator/pdfComponent';
import style from './conclusionButtons.scss';
import { calcPrice, calcWeight } from '../../services/helper';
import SaveConfigurationComponent from '../configuration/SaveConfigurationComponent';

const SellerPdfLink = (props) => {
    // Do not initialize the seller pdf if the user is not logged in
    const configuration = props.configuration;
    const price = props.price;
    const weight = props.weight;

    if (props.disabled === false && typeof configuration.userData !== 'undefined' && configuration.userData !== null) {
        return (
            <PDFDownloadLink
                className={style.pdfLink}
                document={
                    <SellerPdf
                        configurations={configuration.configurations}
                        formData={configuration.formData}
                        model={configuration.model}
                        price={price}
                        weight={weight}
                        userData={configuration.userData}
                    />
                }
                fileName="doc.pdf"
            >
                {({ loading }) => (loading ?
                    <button disabled>
                        <div className={style.iconAttachment} />
                        {t`Lade Händler-PDF`}...
                    </button> :
                    <button>
                        <div className={style.iconAttachment} />
                        {t`PDF Download (Händler)`}
                    </button>)}
            </PDFDownloadLink>
        );
    }
    return null;
};

class ConclusionButtons extends Component {
    render = () => {
        const props = this.props;
        const { configuration } = props;
        const price = calcPrice(configuration);
        const weight = calcWeight(configuration);

        return (
            <div className={style.buttons}>
                <SaveConfigurationComponent />
                <PDFDownloadLink
                    className={style.pdfLink}
                    document={<CustomerPdf
                        configurations={configuration.configurations}
                        model={configuration.model}
                        price={price}
                        weight={weight}
                    />}
                    fileName="doc.pdf"
                >
                    {({ loading }) => (loading ?
                        <button disabled>
                            <div className={style.iconAttachment} />
                            {t`Lade Kunden-PDF...`}
                        </button> :
                        <button>
                            <div className={style.iconAttachment} />
                            {t`PDF Download (Kunde)`}
                        </button>)}
                </PDFDownloadLink>
                <SellerPdfLink
                    configuration={configuration}
                    price={price}
                    weight={weight}
                    disabled={this.props.showForm.visibility}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    configuration: state.configuration,
    showForm: state.showForm,
});

export default connect(mapStateToProps, null)(ConclusionButtons);
